// extracted by mini-css-extract-plugin
export default {"employeeSliderBlock":"employeeSlider_employeeSliderBlock__1fRLM","employeeSlider":"employeeSlider_employeeSlider__c3G8a"};